import { SectionBoxHeader } from 'teacher-ui-client/components/assignments-admin/section-box-header'
import type { TOC } from '@ember/component/template-only'
import type { PhosphorIconName } from 'phosphor-icons'

interface SectionBoxSignature {
  Element: HTMLDivElement
  Args: {
    appearance: LegacyProductRe | LegacyProductRex | LegacyProductMs | LegacyProductWl | LegacyProductFp
    label: string
    icon: PhosphorIconName
    resetAction?: () => void
  }
  Blocks: {
    default: []
  }
}

export const SectionBox: TOC<SectionBoxSignature> = <template>
  <div data-test-section-box class="rounded-lg border-none shadow-md" ...attributes>
    <SectionBoxHeader @label={{@label}} @icon={{@icon}} @appearance={{@appearance}} @resetAction={{@resetAction}} />
    {{yield}}
  </div>
</template>

export default SectionBox
